import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
            最新资讯与攻略
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            游戏资讯、深度评测、实用攻略，助你成为游戏达人
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer no-underline"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
                  {article.category}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.readCount}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/article/article-001"
            className="inline-flex items-center gap-2 px-6 py-3 border border-primary-500 text-primary-600 text-sm font-medium rounded-md hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}